<template>
  <div class="main-container">
    <h3>以下是您最近的登录记录</h3>
    <p>
      若存在异常登录记录，请尽快
      <router-link :to="{ name: 'SetPassword' }">
        修改密码
      </router-link>
    </p>
    <div class="list">
      <van-row>
        <van-col span="10">登录方式</van-col>
        <van-col span="14">登录时间</van-col>
      </van-row>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          :finished="finished"
          finished-text="没有更多了"
          @load="getData"
        >
          <van-row v-for="(item, index) in list" :key="index">
            <van-col span="10">{{ item.type | logintype }}</van-col>
            <van-col span="14" >{{ item.logintime | formatDate }}</van-col>
          </van-row>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import {
  DateUtil
} from '@/utils/date.js'
import { List, PullRefresh } from 'vant'
export default {
  components: {
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      list: [],
      error: false,
      loading: false,
      finished: false,
      refreshing: false,
      total: 9999999
    }
  },
  methods: {
    getData () {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }
      const params = {
        pagesize: 10,
        page: 0
      }
      if (this.list.length >= this.total) {
        this.finished = true
        return false
      }
      params.page = Math.ceil(this.list.length / params.pagesize) + 1
      this.$api.user.getloginrecord(params)
        .then((res) => {
          if (res.data.code === 200) {
            this.list = this.list.concat(res.data.data.data)
            this.total = res.data.data.total
            this.loading = false
          } else {
            this.$notify(res.data.message)
            this.error = true
          }
        })
    },
    onRefresh() {
      this.finished = false
      this.loading = true
      this.getData()
    }
  },
  filters: {
    formatDate: function (time) {
      if (time !== null && time !== '') {
        var date = new Date(time * 1000)
        return DateUtil.formatDateTime(date, 'yyyy-MM-dd H:m:s')
      } else {
        return ''
      }
    },
    logintype: function (type) {
      let typestr = ''
      switch (type) {
        case 1:
          typestr = '手机号登陆'
          break
        case 2:
          typestr = '用户名登录'
          break
        case 3:
          typestr = 'app登录'
          break
        default:
          typestr = '手机号登陆'
      }
      return typestr
    }
  }
}
</script>
<style scoped="scoped" lang="less">
  .list{
    font-size: 16px;
    .van-row {
      padding: 5px 20px;
      border-bottom: 1px solid #dcdcdc;
    }
    .van-col {
      line-height: 28px;
    }
  }
</style>
